import React from "react";
import { calculatePrice } from "./CurrencySelector";

export function PriceDisplay({price, rate, currency}) {
	
	if(!price) return <div className="settings-wrapper price-wrapper"> Select a style and size </div>;

	return (
		<div className="settings-wrapper price-wrapper">
			<div>
				<span>Price </span>
				<span className="price">{ calculatePrice(price, currency, rate) }</span>
			</div>
		</div>
	);
}